import React from "react";
import { Radio, Form } from "antd";
import styled from "styled-components";

import Loading from "components/App/Loading";

import List from "./List";
import Catalog from "./Catalog";
import Fetch from "components/Fetch";

export default function App(props) {
  const { products, list, setList } = props;

  const [form] = Form.useForm();

  const [mode, setMode] = React.useState(0);
  const [product, setProduct] = React.useState([]);
  const [info, setInfo] = React.useState(null);
  const [reload, setReload] = React.useState(false);

  React.useEffect(() => {
    Fetch.get("/products", (res) => {
      if (res) {
        setInfo({
          categories: res.categories,
          brands: res.brands,
        });
        setReload(false);
      }
    });
    setReload(false);
  }, []);

  function handleChange({ target }) {
    setMode(target.value);
  }

  if (!products) {
    return <Loading />;
  }
  return (
    <div style={{ width: "100%" }}>
      <Radio.Group
        onChange={handleChange}
        value={mode}
        optionType="button"
        buttonStyle="solid"
      >
        <Radio.Button value={0}>لیست</Radio.Button>
        <Radio.Button value={1}>کاتالوگ</Radio.Button>
      </Radio.Group>
      <Container>
        {mode === 0 && (
          <List
            product={product}
            setProduct={setProduct}
            reload={reload}
            setReload={setReload}
            {...props}
          />
        )}
        {mode === 1 && (
          <Catalog
            product={product}
            setProduct={setProduct}
            reload={reload}
            setReload={setReload}
            info={info}
            {...props}
          />
        )}
      </Container>
    </div>
  );
}
const Container = styled.div`
  margin-top: 28px;
`;
